export default __webpack_public_path__ + "static/media/parle-agro.119a447d.png";